import React, { Component } from "react";
import { Grid, Row, Col, Thumbnail } from "react-bootstrap";
import "./Projects.css";
import config from "../config.projects";
import Lightbox from "react-image-lightbox";
import "react-image-lightbox/style.css";
import Slider from "react-slick";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";

export default class Projects extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isOpen: false,
      project: null,
      photoIndex: 0,
    };
  }
  renderProject(project, index) {
    const { base, imgs, title, customer } = project;
    return (
      <Col lg={4} md={6} key={index}>
        {" "}
        <Thumbnail
          src={base + imgs[0]}
          alt={title}
          onClick={(evt) => {
            this.setState({
              isOpen: true,
              project: project,
              photoIndex: 0,
            });
          }}
        >
          <h4>
            <span className="thumbnail-label">OBRA:</span> {title}
          </h4>
          <h4>
            <span className="thumbnail-label">Mandante:</span> {customer}
          </h4>
        </Thumbnail>
      </Col>
    );
  }
  renderOther(project, index) {
    const { title, customer } = project;
    return (
      <Col lg={6} md={6} key={index}>
        <h4>{title}</h4>
        <p>{customer}</p>
        <hr />
      </Col>
    );
  }
  render() {
    const { isOpen, project, photoIndex } = this.state;
    const images = project && project.imgs ? project.imgs : [];
    return (
      <div className="Projects">
        <Grid>
          <Row>
            <Col md={12}>
              <h3 className="title">Nuestra Experiencia</h3>
            </Col>
          </Row>
          <Row className="parrafo">
            <Col md={12}>
              <p>
                Pizarro Vial Constructora es una empresa con casi una década de experiencia, que a
                través de su operación, desarrollo y construcción de proyectos viales en todo el territorio
                nacional es reconocida por su servicio en el sector, por la calidad de sus obras y la
                responsabilidad en sus compromisos adquiridos.
              </p>
              <p>
                En Pizarro Vial Constructora somos un staff de profesionales y técnicos con vasta
                experiencia en el rubro, con un amplio soporte de maquinaria y equipos que nos
                permiten proyectar y ejecutar obras de pequeña, mediana y gran envergadura
              </p>
            </Col>
          </Row>
          <Row>
            <Carousel
              additionalTransfrom={0}
              arrows
              autoPlaySpeed={2000}
              centerMode={false}
              className=""
              containerClass="container-with-dots"
              dotListClass=""
              draggable
              focusOnSelect={false}
              infinite
              itemClass=""
              keyBoardControl
              minimumTouchDrag={80}
              autoPlay={true}
              pauseOnHover
              renderArrowsWhenDisabled={false}
              renderButtonGroupOutside={false}
              renderDotsOutside={false}
              responsive={{
                desktop: {
                  breakpoint: {
                    max: 3000,
                    min: 1024,
                  },
                  items: 3,
                  partialVisibilityGutter: 40,
                },
                mobile: {
                  breakpoint: {
                    max: 464,
                    min: 0,
                  },
                  items: 1,
                  partialVisibilityGutter: 30,
                },
                tablet: {
                  breakpoint: {
                    max: 1024,
                    min: 464,
                  },
                  items: 2,
                  partialVisibilityGutter: 30,
                },
              }}
              rewind={false}
              rewindWithAnimation={false}
              rtl={false}
              shouldResetAutoplay
              showDots={false}
              sliderClass=""
              slidesToSlide={1}
              swipeable
            >
              {config.projects.map((project, index) => {
                return (
                  <Col md={12}>
                    <div>
                      <Thumbnail
                        src={project.base + project.imgs[0]}
                        onClick={(evt) => {
                          this.setState({
                            isOpen: true,
                            project: project,
                            photoIndex: 0,
                          });
                        }}
                      >
                        <button className="btn">Ver más</button>
                      </Thumbnail>
                      <div className="captions">
                        <h4>
                          <span className="thumbnail-label">OBRA:</span>{" "}
                          {project.title}
                        </h4>
                        <h4>
                          <span className="thumbnail-label">Mandante:</span>{" "}
                          {project.customer}
                        </h4>
                      </div>

                    </div>
                  </Col>
                );
              })}
            </Carousel>
          </Row>
          {isOpen && (
            <Lightbox
              imageTitle={project.title}
              mainSrc={project.base + images[photoIndex]}
              nextSrc={project.base + images[(photoIndex + 1) % images.length]}
              prevSrc={
                project.base +
                images[(photoIndex + images.length - 1) % images.length]
              }
              onCloseRequest={() =>
                this.setState({ isOpen: false, project: null, photoIndex: 0 })
              }
              onMovePrevRequest={() =>
                this.setState({
                  photoIndex: (photoIndex + images.length - 1) % images.length,
                })
              }
              onMoveNextRequest={() =>
                this.setState({ photoIndex: (photoIndex + 1) % images.length })
              }
            />
          )}
        </Grid>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/Projects.js